import { css } from 'lit'

export const MarkdownStyle = css`
  h1 {
    margin: var(--help-panel-title-margin);
    padding: var(--help-panel-title-padding);
    font-size: 20px;
    text-transform: capitalize;
    color: var(--help-panel-h1-title-color);
  }
  h2 {
    margin: var(--help-panel-title-margin);
    padding: var(--help-panel-title-padding);
    font-size: 18px;
    color: var(--help-panel-h2-title-color);
    text-transform: capitalize;
  }
  h3 {
    margin: var(--help-panel-title-margin);
    padding: var(--help-panel-title-padding);
    font-size: 16px;
    color: var(--help-panel-h3-title-color);
  }
  md-icon {
    vertical-align: middle;
  }

  img {
    display: block;
    margin: var(--spacing-large) var(--spacing-large);
    max-width: 90%;
  }
  img[src*='#icon25'] {
    width: 25px;
    height: 25px;
  }
  img[src*='#icon50'] {
    width: 50px;
    height: 50px;
  }
  img[src*='#icon100'] {
    width: 100px;
    height: 100px;
  }
  img[src*='#icon25inlined'],
  img[src*='#icon50inlined'],
  img[src*='#icon100inlined'] {
    display: inline-block;
    margin: var(--spacing-small);
  }
  p {
    margin: var(--help-panel-paragraph-margin);
    font-size: var(--help-panel-font-size);
  }
  [focusBox] {
    display: block;
    padding: var(--help-panel-focusBox-padding);
    border: var(--help-panel-focusBox-border);
    border-radius: var(--help-panel-focusBox-border-radius);
    background-color: var(--help-panel-focusBox-background-color);
    color: var(--help-panel-focusBox-color);
  }

  [subtitle] {
    font-weight: bold;
  }
  [subtitle]::before {
    content: '';
    width: 7px;
    height: 7px;
    display: inline-block;
    border: 3px solid var(--md-sys-color-surface);
    border-radius: 50%;
    margin-right: var(--spacing-small);
  }
  p + ol,
  p + ul {
    font-size: var(--help-panel-content-font-size);
  }
  ol,
  ul {
    padding: 0 0 0 30px;
  }
  ol li,
  ul li {
    margin: 0 0 2px 0;
  }
  a {
    margin-bottom: 0 !important;
    color: var(--help-panel-a-color);
    font-size: var(--fontsize-default);
    text-decoration: underline;
  }
  a md-icon {
    font-size: var(--help-panel-a-icon-size);
    margin: 0;
  }
  a:hover {
    background-color: var(--opacity-light-dark-color);
    font-weight: bold;
  }

  table {
    border-collapse: collapse;
    border: var(--border-dim-color);
    font-size: 0.9em;
  }
  th {
    border-top: 3px solid var(--md-sys-color-on-primary-container);
    background-color: var(--md-sys-color-background);
    color: var(--md-sys-color-on-secondary-container);
  }
  th,
  td {
    border-bottom: var(--border-dim-color);
    padding: var(--spacing-small);
  }
  tr:nth-child(even) {
    background-color: #f6f6f6;
  }
`
